import { api } from "@/services/api";

export interface OktaCredentials {
  client_id: string;
  domain: string;
}

export const oktaIntegationApi = {
  async getCredentials(path: string) {
    const { data } = await api
      .get<OktaCredentials | null>(`okta-integration/${path}`)
      .catch(() => ({ data: null }));

    return data;
  },

  async getPath() {
    const { data } = await api.get<{ path: string | undefined }>("/okta-path");

    return data.path;
  },
};
